import { render, staticRenderFns } from "./Fullcalendar.vue?vue&type=template&id=25667fd0&"
import script from "./Fullcalendar.vue?vue&type=script&lang=js&"
export * from "./Fullcalendar.vue?vue&type=script&lang=js&"
import style0 from "./Fullcalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports